import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { TableTitleCell } from '../../Table'
import { getIsGroupChat } from '../Chat.utils'
import { ChatTableRowTitleGroupChatIcon } from '../ChatTableRowTitleGroupChatIcon'

import * as styles from './ChatTableRowTitle.module.css'

import ChatIcon from '../../../icons/chats.svg'

function ChatTableRowTitle({ item, ...restProps }) {
  const { title, users } = item

  const { t } = useTranslation()

  return (
    <TableTitleCell
      {...restProps}
      AdditionalIcon={
        getIsGroupChat(users) ? ChatTableRowTitleGroupChatIcon : null
      }
      additionalIconProps={{
        tooltipProps: {
          tooltip: t('ChatTable.GroupChatIconHintKey'),
        },
      }}
      avatarProps={{
        Icon: ChatIcon,
      }}
      textClassName={classNames(styles.titleText, {
        [styles.emptyChatTitle]: !title,
      })}
      tooltip={title || t('ChatTable.NoChatTitleHintKey')}
      value={title || t('ChatTable.NoChatTitleKey')}
    />
  )
}

export default ChatTableRowTitle
